import TaskSystemLinesForm from '../../../../components/Operations/TaskSystem/Lines/TaskSystemLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function TaskSystemLinesModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    isUpdatable,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Task Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <TaskSystemLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

TaskSystemLinesModal.propTypes = {}
TaskSystemLinesModal.defaultProps = {}

export default TaskSystemLinesModal
